import { withRouter } from 'react-router';
import { compose, withPropsOnChange, withState } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  getAppointment,
  getAppointmentCanceled,
  getAppointmentInFuture,
  getBarberAdvanceCancelMins,
  getCanCustomerCancel,
  getBarberName,
  getCustomer,
  getRebookLink,
  getServiceName,
  getShop,
  getScheduleLink,
} from './selectors';
import ViewReservation from './components/ViewReservation';
import { fetchReservation, cancelAppointment, clearReservations, fetchThirdPartyPromoCode } from './actions';

const mapStateToProps = state => ({
  reservationError: state.reservation.error,
  appointment: getAppointment(state),
  barberName: getBarberName(state),
  serviceName: getServiceName(state),
  shop: getShop(state),
  customer: getCustomer(state),
  advanceCancelMins: getBarberAdvanceCancelMins(state),
  canCustomerCancel: getCanCustomerCancel(state),
  inFuture: getAppointmentInFuture(state),
  canceled: getAppointmentCanceled(state),
  rebookLink: getRebookLink(state),
  scheduleLink: getScheduleLink(state),
});

const mapDispatchToProps = (dispatch, ownProps) => bindActionCreators({
  fetchReservation: fetchReservation.bind(null, ownProps.params.appointmentId),
  cancelAppointment: cancelAppointment.bind(null, ownProps.params.appointmentId),
  clearReservations,
}, dispatch);


const redirectIfCanceled = compose(
  withRouter,
  withPropsOnChange(
    ['canceled', 'appointmentId'],
    (props) => {
      if (props.params.appointmentId && props.canceled) {
        props.router.replace(`/appointment-canceled/${props.params.appointmentId}`);
      }
    }
  ),
);

const fetchPromoWhenCustomerHasId = compose(
  withPropsOnChange(
    ['customer'],
    (props) => {
      const fetchPromo = async () => {
        await fetchThirdPartyPromoCode(props.customer.id, props.params.appointmentId)
          .then((data) => {
            if (data.length !== 0 && data[0].promo) {
              props.setPromoCode(data[0].promo);
            }
            props.setIsPromoRequested(true);
          })
          .catch(() => {
            props.setIsPromoRequested(true);
          });
      };

      if (props.customer.id && props.isPromoRequested === false) {
        fetchPromo();
      }
    }
  ),
);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  redirectIfCanceled,
  withState('isPromoRequested', 'setIsPromoRequested', false),
  withState('promoCode', 'setPromoCode', null),
  fetchPromoWhenCustomerHasId,
)(ViewReservation);



// WEBPACK FOOTER //
// ./src/app/reservation/ViewReservation.jsx